// Shared emoji reaction set used across chatter posts, chatter comments and
// event/resource comments. `key` is the stable identifier stored on the server;
// `emoji` is the native glyph rendered in the UI.
export const REACTIONS = [
  { key: "thumbs_up", emoji: "👍", label: "Like" },
  { key: "heart", emoji: "❤️", label: "Love" },
  { key: "celebrate", emoji: "🎉", label: "Celebrate" },
  { key: "care", emoji: "🤗", label: "Care" },
  { key: "insightful", emoji: "💡", label: "Insightful" },
  { key: "hundred", emoji: "💯", label: "100" },
  { key: "applause", emoji: "👏", label: "Applause" },
  { key: "thinking", emoji: "🤔", label: "Thinking" },
];

export const REACTION_MAP = Object.fromEntries(REACTIONS.map((r) => [r.key, r]));

// Optimistically toggle the current user's reaction on a message-like object
// ({ reactions: {key:count}, my_reaction }). Enforces one reaction per user.
export function applyReactionToggle(m, key) {
  const reactions = { ...(m.reactions || {}) };
  const prev = m.my_reaction;
  if (prev) reactions[prev] = Math.max(0, (reactions[prev] || 1) - 1);
  let my = null;
  if (prev !== key) { reactions[key] = (reactions[key] || 0) + 1; my = key; }
  const cleaned = Object.fromEntries(Object.entries(reactions).filter(([, v]) => v > 0));
  return { ...m, reactions: cleaned, my_reaction: my };
}
